const variants = {
  warning: {
    background: "rgba(255, 163, 55, 0.10)",
    borderColor: "warning",
  },
  danger: {
    background: "#ED4B9E19",
    borderColor: "failure",
  },
  success: {
    background: "rgba(49, 208, 170, 0.1)",
    borderColor: "success",
  },
  primary: {
    background: "rgba(118, 69, 217, 0.1)",
    borderColor: "secondary",
  },
  vertical: {
    flexDirection: "column",
  },
  info: {
    backgroundColor: "gray700",
    borderColor: "gray200",
  },
};

export default variants;
